import ApiService from "@/core/services/api.service";

// action types
export const GET_ODATA_COMISIONES = "getODataComisiones";
// mutation types
export const SET_ODATA_COMISIONES = "setODataComisiones";
export const SET_ODATA_BOOKING = "setODataBooking";
export const SET_ERROR = "setError";
//const urlBase = 'https://apifacturacionbot.contemporaseguros.com/OdataFacturacionComision'
//const urlBase = 'https://localhost:44396'
const state = {
  errors: null,
  comisiones: []
};

const actions = {

  [GET_ODATA_COMISIONES](context, query) {

    let { page , page_size, filter } = query;
    filter = (filter === undefined) ? "" : filter;
    let url = `?$count=true${filter}`;

    if(page_size !== -1) {
      let skip = (page - 1) * 1;
      url = `?$top=${page_size}&$skip=${skip}&$count=true${filter}`;
      url = `?$count=true${filter}`;
    }

    return new Promise(resolve => {
      //ApiService.setHeader();

       ApiService.get({action: `/OdataFacturacionComision/odata/FacturacionComision`}, url)
        .then(({ data }) => {
          context.commit(SET_ODATA_COMISIONES, data);//no guardamos el estado
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ODATA_COMISIONES](state, comisiones) {
    state.error = {};
    state.comisiones = comisiones;
  },
  [SET_ODATA_BOOKING](state, booking) {
    state.error = {};
    state.booking = booking;
  }
};

export default {
  state,
  actions,
  mutations
};
